import { NextSeo } from 'next-seo'

import { COLLECTION_TYPE_COURSE, CONTENT_TYPES } from 'lib/element-types'

const Preload = () => (
  <NextSeo
    additionalLinkTags={[
      ...CONTENT_TYPES.map((type) => ({
        as: 'image',
        rel: 'prefetch',
        href: typeof type.icon === 'string' ? type.icon : type.icon.src,
        key: typeof type.icon === 'string' ? type.icon : type.icon.src,
      })),
      {
        as: 'image',
        rel: 'prefetch',
        href:
          typeof COLLECTION_TYPE_COURSE.icon === 'string'
            ? COLLECTION_TYPE_COURSE.icon
            : COLLECTION_TYPE_COURSE.icon.src,
        key:
          typeof COLLECTION_TYPE_COURSE.icon === 'string'
            ? COLLECTION_TYPE_COURSE.icon
            : COLLECTION_TYPE_COURSE.icon.src,
      },
    ]}
  />
)

export default Preload
